var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "left-card-container" }, [
    _c("div", { staticClass: "right-side-title-actions" }, [
      _c("span", { staticClass: "left-title" }, [
        _vm._v(_vm._s(_vm.$tc("Workspace", 1)))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "actions-container" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c("v-icon", [_vm._v(" search ")]),
            _vm._v(" "),
            _c("InputField", {
              attrs: {
                inputType: "text",
                value: _vm.search,
                placeholder: _vm.$t("Search"),
                inputStyle: {
                  borderRadius: "0px",
                  width: "130px",
                  borderTop: "none",
                  borderRight: "none",
                  borderLeft: "none",
                  borderBottom: "1px solid rgba(118, 118, 118, 0.50)"
                }
              },
              on: {
                input: function($event) {
                  return _vm.handleSearch($event)
                }
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-div-container" },
      [
        _c("Table", {
          ref: "tableWorkspaces",
          attrs: {
            "scroll-id": _vm.tableId,
            checkbox: false,
            tdWidth: "t-small",
            loading: _vm.loading,
            headers: _vm.headers,
            items: _vm.workspaces,
            sortable: true,
            emitRowClickBusEvent: true
          },
          on: {
            onScrollBottom: _vm.onScrollBottom,
            onScrollTop: _vm.onScrollTop,
            sortClick: _vm.onSortClick
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1271ecb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1271ecb0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Data/Delete/TableViewWorkspaces.vue
// module id = null
// module chunks = 